<button pButton class="icon-action" icon="fa fa-info-circle" pTooltip="Contract Detail" tooltipPosition="top"
        (click)="onClickShowContractInfo(op, $event)">
</button>

<p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true">
  <ng-template pTemplate>
    <table class="table table-striped" style="width: 100%">
      <tbody>
      <tr>
        <td> Name</td>
        <td> {{contractInfo?.contractTitle}} </td>
      </tr>
      <tr>
        <td> Number</td>
        <td> {{contractInfo?.contractNumber}} </td>
      </tr>
      <tr>
        <td> Customer</td>
        <td> {{contractInfo?.customerBusinessName}} </td>
      </tr>
      <tr>
        <td> Status</td>
        <td> {{contractInfo?.currentStatus | titleCase}} </td>
      </tr>
      <tr>
        <td> Billing Type</td>
        <td> {{contractInfo?.billingType}} </td>
      </tr>
      <tr>
        <td> Award Date</td>
        <td> {{contractInfo?.awardDate | date: Format.Date}} </td>
      </tr>
      <tr>
        <td> Total Value</td>
        <td> {{contractInfo?.totalValue| currency:Format.Currency}} </td>
      </tr>
      <tr>
        <td> Total Funded Value</td>
        <td> {{contractInfo?.totalFundedValue | currency:Format.Currency}} </td>
      </tr>
      <tr>
        <td> Start/End Date</td>
        <td> {{contractInfo?.startDate | date: Format.Date}} - {{contractInfo?.endDate | date: Format.Date}}</td>
      </tr>
      <tr>
        <td> Department</td>
        <td> {{contractInfo?.department}} </td>
      </tr>
      <tr>
        <td> Program Manager</td>
        <td> {{contractInfo?.programManager}} </td>
      </tr>
      <tr>
        <td> Description</td>
        <td> {{contractInfo?.description}} </td>
      </tr>
      </tbody>
    </table>
  </ng-template>
</p-overlayPanel>
